import { api } from './api';

// live-handoff v3: Calendar "Llamadas pendientes" queue. Every call is tenant/branch scoped
// SERVER-SIDE (followup_api.py); the UI flags (can_claim/can_act/can_assign/phone_visible)
// are a convenience only. Wrapped in Promise.resolve so a synchronous transport failure
// surfaces as a rejection (error state) instead of breaking the Calendar render.
const call = (fn) => Promise.resolve().then(fn);
const id = (requestId) => encodeURIComponent(requestId);

export const listFollowups = (params = {}) => call(() => api.get('/followup-requests', { params }));
export const getFollowupScope = () => call(() => api.get('/followup-requests/scope'));
export const listFollowupAssignees = () => call(() => api.get('/followup-requests/assignees'));
export const getFollowup = (requestId) => call(() => api.get(`/followup-requests/${id(requestId)}`));
export const claimFollowup = (requestId, { expected_version }) =>
  call(() => api.post(`/followup-requests/${id(requestId)}/claim`, { expected_version }));
export const attemptFollowup = (requestId, { expected_version, note = '', outcome = '' }) =>
  call(() => api.post(`/followup-requests/${id(requestId)}/attempt`, { expected_version, note, outcome }));
export const closeFollowup = (requestId, { expected_version, status, reason = '' }) =>
  call(() => api.post(`/followup-requests/${id(requestId)}/state`, { expected_version, status, reason }));
export const assignFollowup = (requestId, { expected_version, assignee_user_id }) =>
  call(() => api.post(`/followup-requests/${id(requestId)}/assign`, { expected_version, assignee_user_id }));
// Oct 16 (Calendar detail "Volver a llamar"): the server re-dispatches ONE call for the request
// through the guarded manual single-call path (STOP / hours / stop-contact guards) using the phone
// stored on the row; the response is the updated row + { redial: { call_sid, status } }.
export const redialFollowup = (requestId, { expected_version }) =>
  call(() => api.post(`/followup-requests/${id(requestId)}/redial`, { expected_version }));
// The originating call (transcript + summary) for the "Llamada" tab; same endpoint Call History uses.
export const getFollowupCall = (callSid) => call(() => api.get(`/calls/${id(callSid)}/detail`));
